import React from 'react'
import orderStatusLabels from 'App/helpers/labels/orderStatusLabels'
import problemLabels from 'App/helpers/labels/problemLabels'
import VehicleTag from 'App/components/VehicleTag'
import styles from './styles.css'

export default function Content(props) {
  const {order} = props
  return (
    <>
      <div className={styles.head}>
        {order.shift ? <VehicleTag vehicle={order.shift.vehicle} /> : null}
        <div className={styles.divider} />
        <div className={styles.status}>
          {orderStatusLabels[order.status]} ({order.currentPoint + 1}/{order.points.length})
        </div>
      </div>
      <div className={styles.description}>{order.description}</div>
      {order.lastLog ? <div className={styles.log}>{order.lastLog.message}</div> : null}
      {order.activeProblems.map(problem => (
        <div key={problem} className={styles.problem}>
          {problemLabels[problem]}
        </div>
      ))}
      {order.comment ? <div className={styles.comment}>{order.comment}</div> : null}
    </>
  )
}
